import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { TrainingsTrackerModel } from './trainings_tracker_grid';
import { AddTrainingsModel } from 'src/app/Models/addTrainingsModel';
import { AddToolsModel } from 'src/app/Models/addToolsModel';
@Injectable({
  providedIn: 'root'
})
export class TrainingsTrackerService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer' + localStorage.getItem('token')
      },
    ),
  };
  public ApiUrl = environment.apiUrl;
  public GsdUrl = environment.apiUrl
  trainingssId?: number;


  private PrepopulateData: BehaviorSubject<any>;
  private isCopy: BehaviorSubject<boolean>;
  private isView: BehaviorSubject<boolean>;

  constructor(private http: HttpClient) {
    this.PrepopulateData = new BehaviorSubject<any>({});
    this.isCopy = new BehaviorSubject<boolean>(true);
    this.isView = new BehaviorSubject<boolean>(false);
  }

  getFormData(): Observable<any> {
    return this.PrepopulateData.asObservable();
  }

  setFormData(competencyname: any) {
    this.PrepopulateData.next(competencyname);
  }

  getCopyButtonStatus(): Observable<any> {
    return this.isCopy.asObservable();
  }

  setCopyButtonStatus(copyButton: boolean) {
    this.isCopy.next(copyButton);
  }

  getViewButtonStatus(): Observable<any> {
    return this.isView.asObservable();
  }

  setViewButtonStatus(viewButton: boolean) {
    this.isView.next(viewButton);
  }


  public getAllTrainingsDetails(compId: number, subCompId: number, trainingTypeId: number) {
    const url = this.GsdUrl + `Training/GetTrainingByTypeId?competencyId=${compId}&subCompetencyId=${subCompId}&trainingTypeId=${trainingTypeId}`;
    return this.http.get<TrainingsTrackerModel[]>(url, this.httpOptions);
  }

  public deleteTrainingApiCall(trainingId: string): Observable<any> {
    const url = this.GsdUrl + 'Training/DeleteTraining?trainingId=' + trainingId;
    return this.http.delete<any>(url);
  }

  public getId(Id?: number) {
    this.trainingssId = Id;
  }
  public getSessionDetailsById(): Observable<any> {
    const url = this.GsdUrl + 'Training/GetTrainingById?trainingId=' + this.trainingssId;
    return this.http.get<AddToolsModel[]>(url, this.httpOptions);
  }

  getCMFEmployeesListbyCompId(compId, size) {
    const url = `${this.GsdUrl}TrainingSession/GetCMFEmployeesListbyCompId?CompId=${compId}&Size=${size}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  assignTrainingAPI(params) {
    const url = `${this.GsdUrl}TrainingSession/CMFInsertEmployeeTrainingData`;
    return this.http.post(url, params, this.httpOptions);
  }

  getCMFTrainingStatus() {
    const url = `${this.GsdUrl}TrainingSession/GetCMFEmployeeTrainingStatus`;
    return this.http.post<any>(url, {}, this.httpOptions);
  }
  getTrainingData() {
    const url = `${this.GsdUrl}TrainingSession/GetCMFTrainingsWithParticipants`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getCMFTopTrainingsList(params) {  
    const url = `${this.GsdUrl}CMF/GetCMFTopTrainingsList`;
    return this.http.post(url, params, this.httpOptions);
  }

  getTrainingPercentage() {
    const url = `${this.GsdUrl}TrainingSession/GetCMFTrainingPercentages`;
    return this.http.get<any>(url, this.httpOptions);
  }

  deleteCMFTraining(params) {
    const url = `${this.GsdUrl}TrainingSession/DeleteCMFTraining`;
    return this.http.post(url, params, this.httpOptions);
  }

  updateTrainingAPI(params) {
    const url = `${this.GsdUrl}TrainingSession/UpdateCMFTrainingDetails`;
    return this.http.post(url, params, this.httpOptions);
  }

  getServiceAreaList() {
    return this.http.get('./assets/files/EmployeeSkills_ServiceAreaMappings.json');
  }

  getCMFMenteeSummary(employeeId: string) {
    const url = `${this.GsdUrl}TrainingSession/GetCMFMenteeSummaryAsync?menteeEmpId=${employeeId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getCMFMentorSummary(employeeId: string) {
    const url = `${this.GsdUrl}TrainingSession/GetCMFMentorSummaryAsync?mentorEmpId=${employeeId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  updateMentorLogHours(params) {
    const url = `${this.GsdUrl}TrainingSession/CMF_UpdateMenteeDetailsAsync`;
    return this.http.put(url, params, this.httpOptions);
  }

  updateMenteeLogHours(params) {
    const url = `${this.GsdUrl}TrainingSession/CMF_UpdateMentorDetailsAsync`;
    return this.http.put(url, params, this.httpOptions);
  }
}
